import './mobile_category_component.scss'

import { Controller } from 'stimulus'

export default class extends Controller {
  toggleDisplay () {
    this.element.classList.toggle('mobile_category--opened')
  }
}
